import * as React from "react";
import { TradingAccountResources as TradingAccountResourcesData, Currency } from "swan-public-api-client";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { Typography, Card } from "antd";
import { FormattedCurrency } from "../Localisation/FormattedCurrency";
import "./TradingAccountResources.less";

const { Text } = Typography;

interface Props extends WrappedComponentProps {
  tradingAccountResources?: TradingAccountResourcesData;
  currency?: Currency,
  bordered?: boolean;
  className?: string;
}

class TradingAccountResourcesCmp extends React.PureComponent<Props> {
  public render() {
    const cashBalanceLabel = this.props.intl.formatMessage({
      id: "tradingAccountResources.cashBalance"
    });
    const openPnLLabel = this.props.intl.formatMessage({
      id: "tradingAccountResources.openPnL"
    });
    const marginRequirementLabel = this.props.intl.formatMessage({
      id: "tradingAccountResources.marginRequirement"
    });
    const netOpenPositionsLabel = this.props.intl.formatMessage({
      id: "tradingAccountResources.netOpenPositions"
    });
    const netEquityLabel = this.props.intl.formatMessage({
      id: "tradingAccountResources.netEquity"
    });

    return (
      <Card className={`${this.props.className ? this.props.className : ""} trading-account-resources`} bordered={this.props.bordered}>
        <div className="trading-account-resources-grid">
          <div><Text strong>{cashBalanceLabel}</Text></div>
          <div><Text strong>{openPnLLabel}</Text></div>
          <div><Text strong>{marginRequirementLabel}</Text></div>
          <div><Text strong>{netEquityLabel}</Text></div>
          <div><Text strong>{netOpenPositionsLabel}</Text></div>

          <div><FormattedCurrency value={this.props.tradingAccountResources ? this.props.tradingAccountResources.CashBalance : undefined} currency={this.props.currency} /></div>
          <div><FormattedCurrency value={this.props.tradingAccountResources ? this.props.tradingAccountResources.OpenPnl : undefined} currency={this.props.currency} /></div>
          <div><FormattedCurrency value={this.props.tradingAccountResources ? this.props.tradingAccountResources.MarginRequirement : undefined} currency={this.props.currency} /></div>
          <div><FormattedCurrency value={this.props.tradingAccountResources ? this.props.tradingAccountResources.NetEquity : undefined} currency={this.props.currency} /></div>
          <div><FormattedCurrency value={this.props.tradingAccountResources ? this.props.tradingAccountResources.NetOpenPosition : undefined} currency={this.props.currency} /></div>
        </div>
      </Card>
    );
  }
}

export const TradingAccountResources = injectIntl(TradingAccountResourcesCmp);
